export default __webpack_public_path__ + "static/finance-solution-resource-img-b6156126c2863ce0cbecf518682f5300.svg";